// extracted by mini-css-extract-plugin
module.exports = {"baggagePolicies":"SearchBaggagePolicies-module__baggagePolicies___Euzoj","modalOpener":"SearchBaggagePolicies-module__modalOpener___i1m4l"};